module.exports = __webpack_public_path__ + "img/foto-isabela.c5bdca30.png";